


















/* Created- 10 - Apr - 2019 */
import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import ParticaError from "@/Ui-Components/Common/Error/ParticaError.vue";
import ParticaRowContainer from "@/Ui-Components/Common/Container/ParticaRowContainer.vue";
import ParticaColumnContainer from "@/Ui-Components/Common/Container/ParticaColumnContainer.vue";
import ParticaBaseView from "../Base/ParticaBaseView.vue";
import ViewerConfigurationButtons from "@/Ui-Components/ViewerConfiguration/ViewerConfigurationButtons.vue";
import ViewerContentForm from "@/Ui-Components/ViewerConfiguration/ViewerContentForm.vue";
import ParticaCard from "@/Ui-Components/Common/Container/ParticaCard.vue";
import ParticaView from "@/Ui-Components/Common/ParticaView.vue";
import ParticaWebsiteBase from "../../Base/ParticaWebsiteBase.vue";
import { ViewerContentDTO, ViewerContentVersion } from "../../../Generated/ParticaAPI";
import { IViewerContentService } from "../../../BusinessServices/viewercontent";
import { ParticaEvent, eParticaAction, getActionName } from "../../../Models/ParticaEvent";
import { BreadcrumbItem } from "../../../Models/Breadcrumb";
import { IDomainService } from "../../../BusinessServices/domain";


@Component(
	{
		name: "SearchConfiguration",
		components: {
			ParticaError,
			ParticaRowContainer,
			ParticaColumnContainer,
			ViewerConfigurationButtons,
			ViewerContentForm,
			ParticaCard,
			ParticaView
		}
	})
export default class SearchConfiguration extends ParticaWebsiteBase {
	private data: ViewerContentDTO = new ViewerContentDTO();
	private livedata: ViewerContentDTO = new ViewerContentDTO();
	private viewerContentService: IViewerContentService;
	private domainService: IDomainService;
	@Prop() private id: number;


	private async eventHandler(event: ParticaEvent) {
		try {
			this.LoadingStart();
			switch (event.action) {
				case eParticaAction.WEBSITE_VIEWER_CONFIG_SAVE: {
					this.data.content = JSON.stringify(JSON.parse(this.data.content as string));
					await this.viewerContentService.saveSearchConfiguration(this.data);
					this.ShowSnackbar("You configuration has been saved. You can preview it now. You must swap in to live to see changes on your website.");
					await this.init();
					break;
				}
				case eParticaAction.WEBSITE_VIEWER_CONFIG_COPY_LIVE: {
					this.data.content = this.livedata.content;
					break;
				}
				case eParticaAction.WEBSITE_VIEWER_CONFIG_SWAP: {
					await this.viewerContentService.swapSearchConfig(this.id);
					await this.init();
					this.ShowSnackbar("You new configuration has gone live. It may take up to 2 minutes to see the changes. Don't forget to test.");
					break;
				}
				case eParticaAction.WEBSITE_VIEWER_CONFIG_FORMAT_JSON: {
					this.data.content = JSON.stringify(JSON.parse(this.data.content as string), null, 2);
					break;
				}
				case eParticaAction.WEBSITE_VIEWER_CONFIG_PUBLISH_JSON: {
					await this.domainService.publishConfiguration(this.id);
					break;
				}
				default: {
					this.baseEventHandler(event);
				}

			}
		} catch (error) {
			this.ShowErrorDialog(error, `Unhandled event. ${getActionName(event.action)}`);
		} finally {
			this.LoadingEnd();
		}
	}



	@Watch("$route")
	private async change(to: any, from: any) {
		this.breadcrumbs = [];
		await this.init();
	}
	private async mounted() {
		this.viewerContentService = this.particaServices.getViewerContentService();
		this.domainService = this.particaServices.getDomainService();

		this.metadata.name = "Search configuration";
		await this.init();
		await this.getWebsiteNav(this.id);
		const tmp: BreadcrumbItem = {
			text: "Viewer Configuration",
			to: "/websiteconfiguration/" + this.id.toString() + "/",
			disabled: false,
			exact: true
		} as BreadcrumbItem;
		this.breadcrumbs.splice(3, 0, tmp);
	}

	private async init() {
		try {
			this.LoadingStart();
			this.data = await this.viewerContentService.getSearchConfiguration(this.id, ViewerContentVersion.Preview);
			this.data.content = JSON.stringify(JSON.parse(this.data.content as string), null, 2);
			this.livedata = await this.viewerContentService.getSearchConfiguration(this.id, ViewerContentVersion.Live);
		} catch (error) {
			this.ShowErrorDialog(error, "error initializing component.");
		} finally {
			this.LoadingEnd();
		}
	}
}
